import { request } from './request.js'

export const getJoins = () => request.get('join-us')
export const getJoinsById = (id) => request.get('join-us/' + id)
